import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import BtnPrimary from '../../atom/btn-primary/index.tsx'
import { trackMarketingEvent } from '../../../helpers/analytics.ts'
import { normalizeLanguage, withLang } from '../../../utils/langPath.ts'
import './index.css'

interface FlowStep {
	title: string
	text: string
}

const PurchaseFlow: React.FC = () => {
	const { t, i18n } = useTranslation('home')
	const lang = normalizeLanguage(i18n.language)
	const navigate = useNavigate()
	const steps = t('purchaseFlow.steps', { returnObjects: true }) as FlowStep[]

	return (
		<section id='purchase-flow' className='purchase-flow-section' aria-labelledby='purchase-flow-title'>
			<div className='purchase-flow-shell'>
				<div className='purchase-flow-heading'>
					<p className='purchase-flow-eyebrow'>{t('purchaseFlow.eyebrow')}</p>
					<h2 id='purchase-flow-title'>{t('purchaseFlow.title')}</h2>
					<p>{t('purchaseFlow.subtitle')}</p>
				</div>

				<div className='purchase-flow-panel'>
					<div className='purchase-flow-panel-header'>
						<span className='purchase-flow-panel-label'>{t('purchaseFlow.activeBadge')}</span>
						<p>{t('purchaseFlow.galleryNote')}</p>
					</div>

					<ol className='purchase-flow-list'>
						{Array.isArray(steps) && steps.map((step, index) => (
							<li className={`purchase-flow-step ${index === 2 ? 'purchase-flow-step-active' : ''}`} key={step.title}>
								<div className='purchase-flow-step-marker' aria-hidden='true'>{String(index + 1).padStart(2, '0')}</div>
								<div className='purchase-flow-step-content'>
									<h3>{step.title}</h3>
									<p>{step.text}</p>
								</div>
							</li>
						))}
					</ol>

					<div className='purchase-flow-footer'>
						<BtnPrimary
							className='purchase-flow-cta'
							title={t('purchaseFlow.cta')}
							onPress={() => {
								trackMarketingEvent('cta_click', 'purchase_flow_price')
								navigate(withLang(lang, '/price'))
							}}
						/>
					</div>
				</div>
			</div>
		</section>
	)
}

export default PurchaseFlow
